import type { ReactNode } from 'react';

export const symbol_line_weight: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M135-160q-6 0-10.5-4.5T120-175q0-6 4.5-10.5T135-190h690q6 0 10.5 4.5T840-175q0 6-4.5 10.5T825-160H135Zm15-90q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm0-120q-12.75 0-21.37-8.65-8.63-8.66-8.63-21.45v-30.11q0-12.79 8.63-21.29 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.65 8.62 8.66 8.62 21.45v30.11q0 12.79-8.62 21.29-8.63 8.5-21.38 8.5H150Zm0-150q-12.75 0-21.37-8.63Q120-537.25 120-550v-220q0-12.75 8.63-21.38Q137.25-800 150-800h660q12.75 0 21.38 8.62Q840-782.75 840-770v220q0 12.75-8.62 21.37Q822.75-520 810-520H150Z"
		/>
	</svg>
);
